import React from 'react';

import Loading from '../../../components/Loading';
import CycleCard from '../CycleCard/CycleCard';
import CyclesEmptyView from '../CyclesEmptyView/CyclesEmptyView';
import PaginatedContainer from '../../../components/PaginatedContainer/PaginatedContainer';

const CyclesPaginatedContainer = ({ page, cyclesHookResponse }) => {
    const { data: cycles, total, count, loading } = cyclesHookResponse;

    if (!total && loading) {
        return (
            <div className="pt-5">
                <Loading />
            </div>
        );
    }

    const emptyStateShown = !total && !cycles?.length && !loading && page === 1;

    return (
        <PaginatedContainer page={page} count={count} total={total}>
            {emptyStateShown && <CyclesEmptyView />}

            {!emptyStateShown && (
                <ul className="flex flex-col gap-2">
                    {cycles?.map((cycle) => (
                        <CycleCard key={cycle.id} cycle={cycle} />
                    ))}
                </ul>
            )}
        </PaginatedContainer>
    );
};

export default CyclesPaginatedContainer;
